import { render, staticRenderFns } from "./table_main.vue?vue&type=template&id=d363e602&"
import script from "./table_main.vue?vue&type=script&lang=js&"
export * from "./table_main.vue?vue&type=script&lang=js&"
import style0 from "./table_main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports